import React from "react";
import { FmDrawer } from "@/ui-component";
import { useTranslation } from "@/src/i18n/client";
import classnames from "classnames";
import stl from "../productDetails.module.scss";
interface ISpecificationsDrawerProps {
    visible: boolean;
    onClose: (visible: boolean) => void;
}
const SpecificationsDrawer: React.FC<ISpecificationsDrawerProps> = (props) => {
    const { visible, onClose } = props;
    const { t } = useTranslation("productDetail");
    return (
        <FmDrawer
            open={visible}
            onClose={onClose}
            closeable
            className={classnames(stl["package-detail-contaner"])}
            fullHeight
            headerChildren
        >
            <>
                <p className={stl["rxrange-title"]}>
                    {t("productDetail:Rxrange")}
                </p>
                <div className={stl["range-content"]}>
                    {t("productDetail:customarily")}
                </div>
                <p
                    className={classnames(
                        stl["rxrange-title"],
                        stl["margin-top"],
                    )}
                >
                    {t("productDetail:Pleasenoted")}
                </p>
                <div className={stl["range-content"]}>
                    {t("productDetail:prescriptionLimited")}
                </div>
            </>
        </FmDrawer>
    );
};

export default SpecificationsDrawer;
